import reducer from "./reducer";
export { default as OnboardingProcessesAssignment } from "./components/index";
export { default as onboardingProcessesAssignmentReducerName } from "./constants";
export default reducer;
